// import { TLCode } from './enums';
// import { FormError, Translate, Validate } from '../typings/typings';
// import DayPicker from 'react-day-picker';
import moment from 'moment';

export function getFirstSunday(year: number, month: number) {
  // const day = firstDayInMonth(7, month, year).getDate();
  const day = getFirstDayInMonth(6, month, year);
  return day;
}

export function getFirstMonday(year: Number, month: Number) {
  // const day = firstDayInMonth(1, month, year).getDate();
  const day = getFirstDayInMonth(7, month, year);
  return day;
}

function getFirstDayInMonth(day, m, y) {
  let date = moment();
  date.set('year', y);
  date.set('month', m);
  date.set('date', 1);
  // const mondayThisWeek = moment().startOf('isoWeek');
  // const sundayThisWeek = moment()
  //   .startOf('isoWeek')
  //   .add(6, 'd');
  date.weekday(day);
  return date.toDate();
}

function firstDayInMonth(day, m, y) {
  // day is in range 0 Sunday to 6 Saturday
  var y = y || new Date(Date.now()).getFullYear();
  var m = m || new Date(Date.now()).getMonth();
  return new Date(y, m, 1 + ((day - new Date(y, m, 1).getDay() + 7) % 7));
}

export function getS1(year: number) {
  const begin = moment(getFirstMonday(year, 0))
    .startOf('day')
    .toDate();
  const end = moment(getFirstMonday(year, 6))
    .startOf('day')
    .toDate();
  end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
  const semester = new Semester(begin, end, 'S1-' + year, 'S1');
  return semester;
}

export function getS2(year: number) {
  const begin = moment(getFirstMonday(year, 6))
    .startOf('day')
    .toDate();
  const end = moment(getFirstMonday(year + 1, 0))
    .startOf('day')
    .toDate();
  end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
  const semester = new Semester(begin, end, 'S2-' + year, 'S2');
  return semester;
}

export function getSemester(seed: Date) {
  let beginning = new Date();
  let end = new Date();
  let name = '';
  let current = '';
  const year = seed.getFullYear();
  const month = seed.getMonth();
  if (month < 6) {
    beginning.setFullYear(year);
    beginning.setMonth(6);
    // beginning.setDate(getFirstMonday(year, 6));
    beginning = getFirstMonday(year, 6);
    end.setFullYear(year + 1);
    end.setMonth(0);
    // end.setDate(getFirstSunday(year+1, 0));
    end = getFirstSunday(year + 1, 0);
    name = 'S2-' + year;
    current = 'S1';
  } else {
    beginning.setFullYear(year + 1);
    beginning.setMonth(0);
    beginning = getFirstMonday(year + 1, 0);
    end.setFullYear(year + 1);
    end.setMonth(0);
    end = getFirstSunday(year + 1, 6);
    name = 'S1-' + (year + 1);
    current = 'S1';
  }

  let semester = new Semester(beginning, end, name, current);
  semester.beginningStr = moment(beginning).format('YYYY-MM-DD');
  semester.endStr = moment(end).format('YYYY-MM-DD');
  return semester;
}

export function getCurrentSemester(date: Date) {
  let beginning = new Date();
  let end = new Date();
  let name = '';
  let current = '';
  const year = date.getFullYear();

  const firstMondayOfYear = getFirstMonday(year, 0);
  const firstMondayOfS2Year = getFirstMonday(year, 6);

  if (moment(firstMondayOfYear).isAfter(moment(date), 'day')) {
    beginning.setFullYear(year - 1);
    beginning.setMonth(6);
    beginning = getFirstMonday(year - 1, 6);
    end = moment(firstMondayOfYear).subtract(1, 'day').toDate();
    name = 'S2-' + (year - 1);
    current = 'S2';
  }
  else if (moment(firstMondayOfS2Year).isAfter(moment(date), 'day')) {
    beginning.setFullYear(year);
    beginning.setMonth(0);
    beginning = getFirstMonday(year, 0);
    end.setFullYear(year);
    end.setMonth(6);
    end = getFirstSunday(year, 6);
    name = 'S1-' + year;
    current = 'S1';
  }
  else {
    beginning.setFullYear(year);
    beginning.setMonth(6);
    beginning = getFirstMonday(year, 6);
    end.setFullYear(year + 1);
    end.setMonth(0);
    end = getFirstSunday(year + 1, 0);
    name = 'S2-' + (year);
    current = 'S2';
  }

  let semester = new Semester(beginning, end, name, current);
  semester.beginningStr = moment(beginning).format('YYYY-MM-DD');
  semester.endStr = moment(end).format('YYYY-MM-DD');

  return semester;
}

export class Semester {
  beginning: Date;
  end: Date;
  beginningStr: string;
  endStr: string;
  name: string;
  current: string;

  constructor(beginning: Date, end: Date, name: string, current: string) {
    this.beginning = beginning;
    this.end = end;
    this.name = name;
    this.current = current;
  }
}

